var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fab } from '@mui/material';
import { motion } from 'framer-motion';
import { useOnChange } from 'hx-util';
import { useState } from 'react';
import { useKeyPressEvent } from 'react-use';
import { useKeypadContext } from './KeypadProvider';
var variants = {
    down: { scale: 0.8 },
    rest: { scale: 1 },
};
export var KeypadButton = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, shortcut = _a.shortcut, size = _a.size, disabled = _a.disabled, previewMode = _a.previewMode;
    var disableKeypadKeyboard = useKeypadContext().disableKeypadKeyboard;
    var _b = useState(false), isDown = _b[0], setIsDown = _b[1];
    var handleMouseDown = function () {
        if (disabled)
            return;
        setIsDown(true);
    };
    var handleMouseUp = function () { return setIsDown(false); };
    var handleKeyDown = function () {
        if (disableKeypadKeyboard)
            return;
        handleMouseDown();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var handleKeyUp = function () { return handleMouseUp(); };
    useOnChange(disabled, function () {
        var timeout = setTimeout(function () { return setIsDown(false); }, 100);
        return function () { return clearTimeout(timeout); };
    });
    useKeyPressEvent(shortcut, handleKeyDown, handleKeyUp);
    return (_jsx(motion.div, __assign({ animate: isDown ? 'down' : 'rest', variants: variants, className: "keypad-button ".concat(previewMode ? 'pointer-events-none' : '') }, { children: _jsx(Fab, __assign({ className: className, variant: "keypad", size: size, tabIndex: previewMode ? -1 : 0, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleKeyUp, onTouchStart: handleMouseDown, onTouchEnd: handleMouseUp, onClick: onClick, disabled: disabled }, { children: children })) })));
};
export default KeypadButton;
